export default (
  <path
    d="M21.75 12C21.75 6.61524 17.3848 2.25001 12 2.25001C6.61523 2.25001 2.25 6.61524 2.25 12C2.25 16.5726 5.39788 20.4093 9.64463 21.4629V14.9794H7.63411V12H9.64463V10.7162C9.64463 7.39758 11.1464 5.85942 14.4045 5.85942C15.0222 5.85942 16.088 5.98052 16.524 6.10165V8.80255C16.2939 8.77833 15.8942 8.7662 15.3976 8.7662C13.7989 8.7662 13.1812 9.3718 13.1812 10.9463V12H16.3659L15.8188 14.9794H13.1812V21.6786C18.0088 21.0955 21.75 16.9849 21.75 12Z"
    fill="currentColor"
  />
);
